import { IPublicClientApplication } from '@azure/msal-browser';
import { resetCredentialJotais } from 'src/jotai/atom';

export const logout = async (pca: IPublicClientApplication) => {
  resetCredentialJotais();
  await pca.logout();
};
